import { render, staticRenderFns } from "./ExternalCostBasis.vue?vue&type=template&id=f6e2aa8e&"
import script from "./ExternalCostBasis.vue?vue&type=script&lang=js&"
export * from "./ExternalCostBasis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports